module.exports = __webpack_public_path__ + "img/upload.9ed4ad1c.svg";